import React, { useState, useEffect, useRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

const DanhSachBanHangTableRows = ({
    listUserName,
    list,
    btnSuaBanHangClick,
    btnXoaBanHangClick,
    btnInBanHangClick,
    btnInChenhLechClick,
    RoleSua,
    RoleXoa,
    RoleIn
}) => {
    const [showActionIndex, setShowActionIndex] = useState(null);
    const actionRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (actionRef.current && !actionRef.current.contains(e.target)) {
                setShowActionIndex(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const formatPhoneNumber = (input) => {
        try {
            if (!input) return "";
            const str = input.split(';')[0].trim();
            if (str.length === 10) return str.replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3");
            if (str.length === 11) return str.replace(/(\d{4})(\d{3})(\d{4})/, "$1.$2.$3");
            return str;
        } catch (e) { return input; }
    }

    return (
        <>
            {list.map((item, index) => {
                return (
                    <div className="custom-table-row" key={item.OrderID || index} style={{ minHeight: "60px" }} onClick={() => setShowActionIndex(null)}>
                        <div className="custom-table-cell flex-basis-6 flex-basis-6-sm disk-mobile" style={{ justifyContent: 'center'}}>
                            <span className="mobile-column-name color7-bold">STT</span>
                            <div className="center-wrapper word-break"><p className="text-center color7">{item.STT}</p></div>
                        </div>
                        <div className="custom-table-cell flex-basis-14 flex-basis-14-sm" style={{ justifyContent: 'center'}}>
                            <span className="mobile-column-name color7-bold">Mã</span>
                            <div className="center-wrapper word-break">{item.OrderCode}</div>
                        </div>
                        <div className="custom-table-cell flex-basis-22 flex-basis-22-sm" style={{ justifyContent: 'center', lineHeight: '1.5' }}>
                            <span className="mobile-column-name color7-bold">Tên khách hàng</span>
                            <div className="center-wrapper word-break" >
                                {item.CustomerName}
                                {item.CustomerPhone ? (<><br />(ĐT:{formatPhoneNumber(item.CustomerPhone)})</>) : ""}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-end'}}>
                            <span className="mobile-column-name color7-bold">Tiền đơn hàng</span>
                            <div className="center-wrapper color-xanh-bold text-right word-break" style={{ justifyContent: 'flex-end' }}>
                                {formatNumber(Math.round(item.TotalAmount))}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-13 flex-basis-13-sm" style={{ justifyContent: 'flex-end'}}>
                            <span className="mobile-column-name color7-bold">Tiền thanh toán</span>
                            <div className="center-wrapper color-do-bold text-right word-break" style={{ justifyContent: 'flex-end' }}>
                                {formatNumber(Math.round(item.TotalPaid))}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-12 flex-basis-12-sm" style={{ justifyContent: 'center'}}>
                            <span className="mobile-column-name color7-bold">Nhân viên</span>
                            <div className="center-wrapper text-center word-break">
                                {(() => {
                                    const user = listUserName.find(u => u.value === item.CreatedUser);
                                    return user ? user.label : "" || "";
                                })()}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-8 flex-basis-8-sm" style={{ justifyContent: 'center'}}>
                            <span className="mobile-column-name color7-bold">Thời gian</span>
                            <div className="center-wrapper text-center word-break">{getDate(item.CreatedDate)}</div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm word-break" style={{ justifyContent: 'center'}}>
                            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "5px" }} >
                                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                    {RoleIn && (
                                        <a className="iconTableMorman" title="In Phiếu Bán" onClick={() => btnInBanHangClick(item.OrderID)}>
                                            <img src="/app-assets/images/icon-in-danh-sach.png" alt="In" />
                                        </a>
                                    )}
                                    {RoleIn && (
                                        <a className="iconTableMorman" title="In Chênh Lệch" onClick={() => btnInChenhLechClick(item.OrderID)}>
                                            <img src="/app-assets/images/icon-in-phieu-chenh-lech.png" alt="In Chênh Lệch" />
                                        </a>
                                    )}
                                    {RoleSua && (
                                        <a className="iconTableMorman" title="Sửa" onClick={() => btnSuaBanHangClick(item.OrderID)}>
                                            <img src="/app-assets/images/icon-edit-v2.png" alt="Sửa" />
                                        </a>
                                    )}
                                    {RoleXoa && item.IsDeletable === true && (
                                        <a className="iconTableMorman" title="Xóa" onClick={() => btnXoaBanHangClick(item.OrderID)}>
                                            <img src="/app-assets/images/icon-xoa-v2.png" alt="Xóa" />
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>)
};
const DanhSachBanHangTable = ({
    listUserName, list, Total, TotalAmount, TotalPaid,
    btnSuaBanHangClick,
    btnXoaBanHangClick,
    btnInBanHangClick,
    btnInChenhLechClick,
    RoleSua,
    RoleXoa,
    RoleIn
}) => {
    if (!list || list.length === 0) {
        return (
            <div className="custom-table-row">
                <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }

    return (<>
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper" style={{ overflowX: 'auto', width: '100%' }}>
                    <div className="table-headers word-break" style={{ alignItems: 'stretch' }}>
                        <div className="custom-table-header flex-basis-6 flex-basis-6-sm disk-mobile" style={{ justifyContent: 'center'}}>
                            <p>STT <br /> <span className="color-do-bold">[{Total ? Total : 0}]</span></p>
                        </div>
                        <div className="custom-table-header flex-basis-14 flex-basis-14-sm" style={{ justifyContent: 'start'}}>
                            <p>Mã</p>
                        </div>
                        <div className="custom-table-header flex-basis-22 flex-basis-22-sm" style={{ justifyContent: 'start'}}>
                            <p>Tên khách hàng</p>
                        </div>
                        <div className="custom-table-header text-right flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-end'}} >
                            <p>Tiền đơn hàng <br /> <span className="color-xanh-bold">{TotalAmount ? formatNumber(Math.round(TotalAmount)) : 0}</span></p>
                        </div>
                        <div className="custom-table-header text-right flex-basis-13 flex-basis-13-sm" style={{ justifyContent: 'flex-end'}}>
                            <p>Tiền thanh toán <br /> <span className="color-do-bold">{TotalPaid ? formatNumber(Math.round(TotalPaid)) : 0}</span></p>
                        </div>
                        <div className="custom-table-header flex-basis-12 flex-basis-12-sm" style={{ justifyContent: 'center'}} >
                            <p>Nhân viên</p>
                        </div>
                        <div className="custom-table-header flex-basis-8 flex-basis-8-sm" style={{ justifyContent: 'center'}}>
                            <p>Thời gian</p>
                        </div>
                        <div className="custom-table-header flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center'}}>
                            <p>Thao tác</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        <DanhSachBanHangTableRows
                            listUserName={listUserName}
                            list={list}
                            btnSuaBanHangClick={btnSuaBanHangClick}
                            btnXoaBanHangClick={btnXoaBanHangClick}
                            btnInBanHangClick={btnInBanHangClick}
                            btnInChenhLechClick={btnInChenhLechClick}
                            RoleSua={RoleSua}
                            RoleXoa={RoleXoa}
                            RoleIn={RoleIn}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default DanhSachBanHangTable;